import React from 'react';
import { Modal, Input, Form, Select } from 'antd';

import { DNI, RUC} from '../../../common/types/tipoDocumentoType';
import { FORMAT_NUMBER } from '../../../common/types/regularExpresionType';
import { FORMAT_EMAIL } from '../../../common/types/regularExpresionType';

const { Option } = Select;
const { Search } = Input;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleChangeTipoDocumento = (option) => {
        this.props.form.setFieldsValue({
            numeroDocumento: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            idTipoDocumento:undefined,
        }, () => {
            this.props.form.validateFields(["numeroDocumento"]);
            this.props.onChange("clear");
        });
    }

    numeroDocumentoCustomValidation = (rule, value, callback) => {
        var idTipoDocumento = this.props.form.getFieldValue('idTipoDocumento').key;
        var numeroDocumentoLongitud = this.props.form.getFieldValue('numeroDocumento').length;

        if (idTipoDocumento === DNI.ID) {
            var regexp = new RegExp(FORMAT_NUMBER);
            if (!regexp.test(value))
                callback(`Formato DNI invalido.`);
            else if (numeroDocumentoLongitud !== 8 && numeroDocumentoLongitud > 0)
                callback('La longitud de ser de 8 caracteres.');
        }
        if (idTipoDocumento === RUC.ID) {
            var regexp = new RegExp(FORMAT_NUMBER);
            if (!regexp.test(value))
                callback(`Formato RUC invalido.`);
            else if (numeroDocumentoLongitud !== 11 && numeroDocumentoLongitud > 0)
                callback('La longitud de ser de 11 caracteres.');
        }

        callback();
    }

    correoCustomValidation = (rule, value, callback) => {
        var regexp = new RegExp(FORMAT_EMAIL);
        if (value !== null && value.length > 0 && !regexp.test(value))
            callback('Formato de correo invalido.');
            
        callback();
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idTipoDocumento: values.idTipoDocumento.key,
                    idTipoVendedor: values.idTipoVendedor.key,

                    numeroDocumento: values.numeroDocumento,
                    nombre: values.nombre==undefined ? null : values.nombre,
                    razonSocial: values.razonSocial==undefined ? null : values.razonSocial,
                    apellidoPaterno: values.apellidoPaterno ==undefined ? null : values.apellidoPaterno,
                    apellidoMaterno: values.apellidoMaterno==undefined ? null : values.apellidoMaterno,
                    direccion: values.direccion,
                    correo: values.correo,
                    telefono: values.telefono
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Vendedor" : "Modificar Vendedor"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="800px"
            >
                <Form>
                    <div className="row">

                    <div className="col-md-4 form-group">
                            <Form.Item label="Tipo de Vendedor">
                                {getFieldDecorator('idTipoVendedor', {
                                    initialValue: this.props.formValues.idTipoVendedor ?
                                        { key: this.props.formValues.idTipoVendedor } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione tipo de vendedor"}
                                        optionFilterProp="children"
                                        onChange={this.handleChangeTipoDocumento}
                                    >
                                        {this.props.formValues.tipoVendedor.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo de Documento">
                                {getFieldDecorator('idTipoDocumento', {
                                    initialValue: this.props.formValues.idTipoDocumento ?
                                        { key: this.props.formValues.idTipoDocumento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    this.props.form.getFieldValue('idTipoVendedor').key == 1 ?
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione tipo de documento"}
                                            optionFilterProp="children"
                                            onChange={this.handleChangeTipoDocumento}
                                        >
                                            {this.props.formValues.tiposDocumento.map(item => (
                                                item.abreviatura!='RUC'?
                                                <Option key={item.id} value={item.id}>{item.abreviatura}</Option>
                                                :null
                                            ))}
                                        </Select> :

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione tipo de documento"}
                                            optionFilterProp="children"
                                            onChange={this.handleChangeTipoDocumento}
                                        >
                                            {this.props.formValues.tiposDocumento.map(item => (
                                                item.abreviatura=='OTROS' || item.abreviatura=='RUC'  ?
                                                <Option key={item.id} value={item.id}>{item.abreviatura}</Option>
                                                : null
                                            ))}
                                        </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Número Documento">
                                {getFieldDecorator('numeroDocumento', {
                                    initialValue: this.props.formValues.numeroDocumento,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        },
                                        {
                                            validator: this.numeroDocumentoCustomValidation
                                        }
                                    ]
                                })(
                                    <Search
                                        placeholder="Búsqueda por Documento"
                                        autoComplete="off"
                                        maxLength={50}
                                        loading={this.props.formValues.searchLoading}
                                        onSearch={value => this.props.onBuscarPadronReducido(this.props.form.getFieldValue('idTipoDocumento').key, value, this.props.form)}
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>
                    <div className="row">

                        <div className="col-md-12 form-group">
                            {this.props.form.getFieldValue('idTipoVendedor').key== 1?
                            <Form.Item label='Nombre'>
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>:

                            <Form.Item label={'Razon Social'}>
                                {getFieldDecorator('razonSocial', {
                                    initialValue: this.props.formValues.razonSocial,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar razonSocial"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                            }
                        </div>
                    </div>

                    {this.props.form.getFieldValue('idTipoVendedor').key == 1 ?
                        <div className="row">
                            <div className="col-md-6 form-group">
                                <Form.Item label="Apellido Paterno">
                                    {getFieldDecorator('apellidoPaterno', {
                                        initialValue: this.props.formValues.apellidoPaterno,
                                        rules: [{
                                            required: false,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Apellido Paterno"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <div className="col-md-6 form-group">
                                <Form.Item label="Apellido Materno">
                                    {getFieldDecorator('apellidoMaterno', {
                                        initialValue: this.props.formValues.apellidoMaterno,
                                        rules: [{
                                            required: false,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Apellido Materno"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                        : null}


                    <div className="row">

                    <div className="col-md-12 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('direccion', {
                                    initialValue: this.props.formValues.direccion,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                        whitespace: true,
                                        maxLength:40
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Dirección"
                                        autoComplete="off"
                      
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-6 form-group">
                            <Form.Item label="Telefono">
                                {getFieldDecorator('telefono', {
                                    initialValue: this.props.formValues.telefono,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                        whitespace: true,
                                        maxLength:40
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Telefono"
                                        autoComplete="off"
                                        type="tel"
                                        maxLength="40"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Correo">
                                {getFieldDecorator('correo', {
                                    initialValue: this.props.formValues.correo,
                                    rules: [
                                        {
                                            validator: this.correoCustomValidation,
                                            maxLength:40
                                        }
                                    ]
                                })(
                                    <Input
                                        placeholder="Ingresar Correo"
                                        autoComplete="off"
                                        type="mail"
                                        maxLength="40"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)